import {createTheme} from "@mui/material/styles";

const theme = createTheme({
    palette: {
        primary: {
            main: "#000000",
        },
        secondary: {
            main: "#9D1681",
        },
        error: {
            main: "#00B2BB",
        },
        warning: {
            main: "#00B2BB",
        },
        info: {
            main: "#000000",
        },
        success: {
            main: "#9D1681",
        },
    },
    typography: {
        fontFamily: ["Roboto", "Helvetica", "Arial", "sans-serif"].join(","),
    },
    components: {
        MuiTextField: {
            defaultProps: {
                variant: "standard"
            }
        },
        MuiSelect: {
            defaultProps: {
                variant: "standard"
            }
        },
        MuiCssBaseline: {
            styleOverrides: {
                body: {
                    fontSize: '0.875rem',
                    lineHeight: 1.43,
                },
            },
        },
        // use white text instead of black
        MuiAlert: {
            styleOverrides: {
                root: ({ownerState}) => ({
                    ...(ownerState.variant === "filled" && {
                        color: "#fff"
                    })
                })
            }
        }
    }
});

export default theme